// extracted by mini-css-extract-plugin
module.exports = {"root":"categoryLayout_root__XQRlw","title":"categoryLayout_title__2Pr6W","container":"categoryLayout_container__2BiMo"};